export default __webpack_public_path__ + "static/media/can.83ee1c57.png";